<template>
  <table class="table is-fullwidth is-hoverable" id="timber-table-full-result">
    <thead>
      <tr>
        <td>Holzart</td>
        <td>Qualität</td>
        <td>Stärkeklasse</td>
        <td style="min-width: 5.6em;">Summe</td>
        <td>Anzahl</td>
      </tr>
    </thead>
    <tbody>
      <!-- FOR EACH WOOD TYPE-->
      <template v-for="(woodType, index) in woodResults">
        <!-- FOR EACH QUALITY -->
        <template v-for="(quality, indexQuality) in woodType.qualities">
          <template v-if="quality.volume > 0">
            <!-- FOR EACH STRENGTH CLASS -->
            <template v-for="(strengthClass, indexStrength) in quality.strengthClasses">
              <template v-if="strengthClass.volume > 0">
                <!-- eslint-disable-next-line vue/valid-v-for -->
                <tr
                  v-if="woodType.volume > 0"
                  v-bind:key="
                    woodType.name +
                      '_(' +
                      index +
                      ')_' +
                      quality.name +
                      '_' +
                      'strength' +
                      indexStrength +
                      '_volume'
                  "
                >
                  <!-- NAME OF THE WOOD TYPE IN THE FIRST ROW -->
                  <th
                    v-if="indexQuality === 0 && indexStrength === 0"
                    :rowspan="getAmountOfRowsForWoodType(woodType)"
                    class="has-text-weight-bold"
                  >{{ woodType.name }}</th>
                  <!-- NAME OF THE QUALITY IN THE FIRST ROW -->
                  <td
                    v-if="indexStrength === 0"
                    :rowspan="getAmountOfRowsForQuality(quality, woodType.qualities.length)"
                    v-bind:key="woodType.name + '_quality_' + indexQuality"
                  >{{ quality.name }}</td>
                  <!-- NAME OF THE STRENGTH CLASS IN EVERY CASE -->
                  <td
                    class="has-text-centered"
                    v-bind:key="
                      woodType.name +
                        '_' +
                        quality.name +
                        '_' +
                        'strength' +
                        indexStrength +
                        '_name'
                    "
                  >{{ strengthClass.name }}</td>
                  <!-- VOLUME OF THE STRENGTH CLASS-->
                  <td
                    v-bind:key="
                      woodType.name +
                        '_' +
                        quality.name +
                        '_' +
                        'strength' +
                        indexStrength +
                        '_volume'
                    "
                    v-bind:data-cy="woodType.name +
                        '_' +
                        quality.name +
                        '_' +
                        strengthClass.name + 
                        '_volume'"
                  >{{ round(strengthClass.volume) }} &nbsp;m³
                  </td>
                  <td>
                    <small>{{ strengthClass.quantity }} Stk.</small>
                  </td>
                </tr>

                <!-- VOLUME SUM OF QUALITY -->
                <template
                  v-if="indexStrength === quality.strengthClasses.length - 1 
                  && quality.strengthClasses.length > 1
                  && woodType.qualities.length > 1"
                >
                  <tr
                    v-bind:key="woodType.name + 
                        '_' +
                        quality.name +
                        '_' +
                        'strength' +
                        indexStrength +
                        '_row_sum'
                    "
                    class="quality-total-volume"
                  >
                    <th>
                      <span class="is-hidden">Summe {{ quality.name }}</span>
                    </th>
                    <th
                      v-bind:data-cy="woodType.name +
                        '_' +
                        quality.name + 
                        '_volume'"
                    >{{ round(quality.volume) }} &nbsp;m³
                    </th>
                  <th>
                    <small>{{ quality.quantity }} Stk.</small>
                  </th>
                  </tr>
                </template>

                <!-- VOLUME SUM OF WOOD TYPE -->
                <template
                  v-if="
                    indexQuality === woodType.qualities.length - 1 &&
                      indexStrength === quality.strengthClasses.length - 1
                  "
                >
                  <tr
                    v-bind:key="
                      woodType.name +
                        '_' +
                        quality.name +
                        '_' +
                        'strength' +
                        indexStrength +
                        '_row'
                    "
                    class="wood-type-total-volume"
                  >
                    <th colspan="2">Gesamt</th>
                    <th
                      v-bind:data-cy="woodType.name + '_volume'"
                    >{{ round(woodType.volume) }} &nbsp;m³
                    </th>
                    <th>
                      <small>{{ woodType.quantity }} Stk.</small>
                  </th>
                  </tr>
                </template>
              </template>
            </template>
            <!-- END STRENGTH CLASS -->
          </template>
        </template>
        <!-- END QUALITY-->
      </template>
      <!-- END WOOD TYPE-->
    </tbody>
  </table>
</template>

<script>
import helperMixin from "../mixins/helper-mixin.js";

export default {
  name: "timber-table-full-results",
  mixins: [helperMixin],
  props: {
    rows: Array,
    woodMesauredWithBark: Boolean
  },
  data() {
    return {
      woodTypes: ["Fichte", "Tanne", "Lärche", "Douglasie", "Kiefer"],
      qualityClasses: ["B", "B/C", "C", "CK", "C/G", "D"],
      strengthClasses: [
        "1a",
        "1b",
        "2a",
        "2b",
        "3a",
        "3b",
        "4a",
        "4b",
        "5",
        "6"
      ]
    };
  },
  computed: {
    woodResults: function() {
      var tmp = [];
      this.woodTypes.forEach(function(x, indexWoodType) {
        var obj = {
          name: x,
          volume: this.getVolumeByWoodType(x),
          quantity: this.getAmountByWoodType(x),
          id: indexWoodType,
          qualities: []
        };

        if (obj.volume > 0) {
          this.qualityClasses.forEach(function(y, indexQuality) {
            var qualObj = {
              name: y,
              volume: this.getVolumeByWoodTypeAndQuality(x, y),
              quantity: this.getAmountByWoodTypeAndQuality(x,y),
              id: indexQuality,
              strengthClasses: []
            };

            if (qualObj.volume > 0) {
              this.strengthClasses.forEach(function(z, indexStrength) {
                var strObj = {
                  name: z,
                  index: indexStrength,
                  volume: this.getVolumeByWoodTypeAndQualityAndStrengthClass(
                    x,
                    y,
                    z
                  ),
                  quantity: this.getAmountByWoodTypeAndQualityAndStrengthClass(x,y,z),

                };
                if (strObj.volume > 0) {
                  qualObj.strengthClasses.push(strObj);
                }
              }, this);
              obj.qualities.push(qualObj);
            }
          }, this);
          tmp.push(obj);
        }
      }, this);
      this.$emit("resultsChanged", tmp);
      return tmp;
    }
  },
  methods: {
    getAmountOfRowsForWoodType: function(woodTypeObject) {
      let amountOfRows = 1; // for the wood type total sum

      woodTypeObject.qualities.forEach(function(x) {
        // iterate over the qualities
        amountOfRows += x.strengthClasses.length; // add the amount of strengthclasses to total amount#
        // add for each quality a row for the total sum
        if (
          x.strengthClasses.length > 1 &&
          woodTypeObject.qualities.length > 1
        ) {
          amountOfRows++;
        }
      }, this);
      return amountOfRows;
    },
    getAmountOfRowsForQuality: function(qualityObject, amountOfQualities) {
      if (qualityObject.strengthClasses.length > 1 && amountOfQualities > 1) {
        return qualityObject.strengthClasses.length + 1;
      } else {
        return qualityObject.strengthClasses.length;
      }
    },
    getAmountOfLogs() {
      return this.rows.length;
    },
    getAverageDiameter() {
      var diameterCumulated = this.rows
        .map(function(m) {
          return m.diameter;
        })
        .reduce(function(accumulator, r) {
          return accumulator + Number(r);
        }, 0.0);
      return diameterCumulated / this.getAmountOfLogs();
    },
    getAverageDiameterWithoutBark() {
      var diameterCumulated = this.rows
        .map(function(m) {
          return m.diameterWithoutBark;
        })
        .reduce(function(accumulator, r) {
          return accumulator + Number(r);
        }, 0.0);
      return diameterCumulated / this.getAmountOfLogs();
    },
    getAverageLength() {
      var diameterCumulated = this.rows
        .map(function(m) {
          return m.length;
        })
        .reduce(function(accumulator, r) {
          return accumulator + Number(r);
        }, 0.0);
      return diameterCumulated / this.getAmountOfLogs();
    },
    getVolumeByWoodType(woodType) {
      return this.rows
        .filter(function(x) {
          return x.woodType === woodType;
        })
        .map(function(m) {
          return m.volume;
        })
        .reduce(function(accumulator, r) {
          return accumulator + Number(r);
        }, 0.0);
    },
    getVolumeByWoodTypeAndQuality(woodType, quality) {
      return this.rows
        .filter(function(x) {
          return x.woodType === woodType && x.quality === quality;
        })
        .map(function(m) {
          return m.volume;
        })
        .reduce(function(accumulator, r) {
          return accumulator + Number(r);
        }, 0);
    },
    getVolumeByWoodTypeAndQualityAndStrengthClass(
      woodType,
      quality,
      strengthClass
    ) {
      return this.rows
        .filter(function(x) {
          return (
            x.woodType === woodType &&
            x.quality === quality &&
            x.strengthClass === strengthClass
          );
        })
        .map(function(m) {
          return m.volume;
        })
        .reduce(function(accumulator, r) {
          return accumulator + Number(r);
        }, 0);
    },
    getAmountByWoodType(woodType) {
      return this.rows
        .filter(function(x) {
          return x.woodType === woodType && x.volume && x.diameter
        })
        .length;
    },
    getAmountByWoodTypeAndQuality(woodType, quality) {
      return this.rows
        .filter(function(x) {
          return x.woodType === woodType && x.quality === quality && x.volume && x.diameter
        })
        .length;
    },
    getAmountByWoodTypeAndQualityAndStrengthClass(
      woodType,
      quality,
      strengthClass
    ) {
      return this.rows
        .filter(function(x) {
          return (
            x.woodType === woodType &&
            x.quality === quality &&
            x.strengthClass === strengthClass && x.volume && x.diameter
          );
        })
        .length;
    }
  }
};
</script>

<style scoped>
#timber-table-full-result > tbody > tr > th[rowspan^=]:last-of-type {
  /* border: none; */
  border-bottom: 1px solid black;
}
#timber-table-full-result .wood-type-total-volume th {
  border-bottom: 1px solid black;
}
#timber-table-full-result .quality-total-volume th {
  border-style: double;
  border-top-width: 5px;
  font-weight: 400;
}
.wood-type-total-volume th {
  border-bottom: 1px solid black;
}
</style>
